/*
	=======
	Modules
	=======

	Module level CSS should be placed in this file.
	Modules are self-contained sections of markup.
	Modules can exist with other modules.
	Modules can often include objects.

	EXAMPLES::

	"Site Header" would be a module.

	"Top Navigation" may exist within the "Site Header" markup but it is capable of existing as its own module and so should be done separately.
*/


/*	=========
	No Script
	=========  */
.site-alert {
	background: #FFF;
	border-bottom: 2px solid #F00;
	display: block;
	font-family: sans-serif;
	font-size: rem(12);
	left: 0;
	padding: 5px 0;
	text-align: center;
	top: 0;
	width:100%;
	z-index: 100;
}
/* No Script */


/*
	===========
	Site Footer
	===========
*/
.site-footer {
	p {
		font-size: rem(18);
		margin-left: auto;
		margin-right: auto;
		max-width: 280px;
	}
	.link,
	.large {
		font-size: rem(18);
	}
}
/* Site Footer */


/*
	============
	Site Content
	============
*/
.content-site {
	padding-top: 10px;
	padding-bottom: 10px;
}
/* Site Content */


/*
	==========
	Navigation
	==========
*/
.nav-main {
	clear: right;
	color: #53565a;
	font-size: rem(18);
	margin-top: 10px;
	text-transform: uppercase;

	@include max(767px) {
		display: none;
	}

	@include min(768px) {
		margin-top: 20px;
		text-align: center;
	}

	> ul {
		> li {
			display: block;

			@include min(768px) {
				display: inline-block;
			}
		}
	}

	ul {
		margin: 0;
		padding: 0;

		ul {
			@include min(768px) {
				background-color: #FFF;
				border-radius: $border-radius;
				box-shadow: 0 0 5px $colour-base;
				left: -999em;
				min-width: 200px;
				padding-left: 0;
				position: absolute;
				text-align: left;
			}
		}
	}

	li {
		position: relative;

		&:hover,
		&:focus,
		&.focus {
			> ul {
				left: auto;
				right: 0;
			}
		}

		li {
			+ li {
				border-top: 1px solid $colour-base;
			}
		}
	}

	a {
		@extend %linkhover;
		border-radius: $border-radius;
		color: inherit;
		display: block;
		font-weight: 700;
		padding: 10px 20px;
		position: relative;
		text-decoration: none;
		transition: color 0.5s;

		&:before {
			background-color: $colour-highlight;
		}

		&:focus,
		&:hover {
			color: #FFF;

			+ ul {
				left: auto;
				right: 0;
			}
		}
	}

	.active {
		> a {
			background-color: $colour-highlight;
			color: #FFF;
		}

		&[data-item="get-active"] {
			> a {
				background-color: $colour-alt;

				&:before {
					background-color: $colour-alt;
				}
			}
		}
		&[data-item="lose-weight"] {
			> a {
				background-color: $colour-highlight;

				&:before {
					background-color: $colour-highlight;
				}
			}
		}
		&[data-item="stop-smoking"] {
			> a {
				background-color: $colour-smoking;

				&:before {
					background-color: $colour-smoking;
				}
			}
		}
		&[data-item="drink-less"] {
			> a {
				background-color: $colour-drink;

				&:before {
					background-color: $colour-drink;
				}
				color: $colour-base;
			}
		}
	}

	li {
		&[data-item="get-active"] {
			> a {
				&:before {
					background-color: $colour-alt;
				}

				&:hover {
					color: #FFF;
				}
			}
		}
		&[data-item="lose-weight"] {
			> a {
				&:before {
					background-color: $colour-highlight;
				}

				&:hover {
					color: #FFF;
				}
			}
		}
		&[data-item="stop-smoking"] {
			> a {
				&:before {
					background-color: $colour-smoking;
				}

				&:hover {
					color: #FFF;
				}
			}
		}
		&[data-item="drink-less"] {
			> a {
				&:before {
					background-color: $colour-drink;
				}
			}
		}
	}
}

.nav-mobile {
	background-color: $colour-highlight;
	color: #FFF;
	display: none;
	font-weight: 700;
	overflow: auto;
	overflow-x: hidden;
	position: fixed;
	top: 0;
	left: -50vw;
	right: 0;
	height: 100vh;
	width: 50vw;
	text-transform: uppercase;
	transition: left 0.3s, width 0.3s;
	z-index: 100;

	@include max(767px) {
		display: block;
	}

	ul {
		@extend %list-reset;

		+ ul {
			padding-top: 0;
		}
	}

	li {
		+ li {
			margin-top: 5px;
		}
	}

	a {
		border-radius: $border-radius;
		color: inherit;
		display: block;
		padding: 5px 10px;
		text-decoration: none;
	}

	.active {
		> a {
			background-color: $colour-highlight;
			color: #FFF;
		}
	}

	.nav-mobile_inner {
		padding-bottom: 50px;
		padding-top: 20px;
		width: 100vw;

		> ul {
			padding: 0;

			+ ul {
				padding-top: 0;
			}

			ul {
				padding-top: 5px;

				a {
					&:before {
						content: '- ';
					}
				}
			}
		}
	}
}

.site_nav_open {
	height: 100vh;
	overflow: hidden;

	.nav-mobile {
		left: 0;
		width: 100vw;
	}
}


.nav-main_toggle {
	font-weight: 700;
	padding-right: 36px;
	position: absolute;
	text-transform: uppercase;
	top: 11px;
	right: 10px;
	z-index: 110;

	@include min(768px) {
		display: none;
	}
}

.nav-main_toggle_icon  {
	background-color: transparent;
	background-image: none;
	position: absolute;
	right: 8px;
	top: 50%;
	margin-top: -7.5px;
	height: 15px;
	width: 20px;
	vertical-align: middle;

	span {
		background-color: #FFF;
		border-radius: 50px;
		height: 20%;
		left: 0;
		opacity: 1;
		position: absolute;
		transform-origin: center center;
		width: 100%;
		transition: all 0.6s ease-in-out;

		&:nth-child(1) {
			top: 0;
			transform-origin: 0 0;
		}

		&:nth-child(2) {
			top: 40%;
		}

		&:nth-child(3) {
			top: 80%;
			transform-origin: left bottom;
		}

		&:nth-child(4) {
			opacity: 0;
			top: 40%;
		}
	}

	.nav-main_toggle_open & {
		span {
			&:nth-child(2),
			&:nth-child(4) {
				top: 40%;
			}

			&:nth-child(1) {
				opacity: 0;
			}

			&:nth-child(2) {
				transform: rotateZ(45deg);
			}

			&:nth-child(3) {
				opacity: 0;
			}

			&:nth-child(4) {
				opacity: 1;
				transform: rotateZ(-45deg);
			}
		}
	}
}

.nav-side {
	ul {
		border-left: 1px solid $colour-highlight;

		ul {
			border-left-width: 4px;
			margin-top: 2px;
			// padding-left: 10px;
		}
	}

	li {
		+ li {
			margin-top: 2px;
		}
	}

	a {
		background-color: #EEE;
		border-radius: $border-radius;
		display: block;
		padding: 5px;
		transition: background-color 0.5s;

		&:focus,
		&:hover {
			background-color: #CCC;
		}
	}
}

.nav-footer {
	display: flex;
	flex-direction: column;
    justify-content: center;
    margin: 0 rem(24);
    width: calc(100% - rem(24 * 2));

	@include min(1200px) {
		margin: 0 rem(96);
		width: calc(100% - rem(96 * 2));
	}

	.nav-footer-top {
		display: flex;
		width: 100%;
		justify-content: center;
		padding-bottom: rem(24);

		.logo {
			display: none;
		}

		.nav-footer-top-social {
			display: flex;

			a {
				display: flex;
				text-decoration: none;
				margin-right: rem(20);

				&:last-of-type {
					margin-right: 0;
				}
			}
		}

		@include min(768px) {
			justify-content: space-between;
			border-bottom: 3px solid $colour-primary-500;
			padding-bottom: rem(32);

			.logo {
				display: flex;

				img {
					height: rem(56);
				}
			}

			.nav-footer-top-social {
				a {
					margin-right: rem(16);
				}
			}
		}
	}

	.nav-footer-bottom {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;

		.nav-footer-bottom-main, .nav-footer-bottom-secondary {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-top: rem(24);
			padding-bottom: rem(24);

			a {
				font-family: $font-header-medium;
				font-weight: 400;
				font-size: rem(26);
				line-height: 120%;
				letter-spacing: 0.25px;
				color: $core-neutral-900;
				text-decoration: none;
				padding: rem(12) 0;

				&:last-of-type {
					margin-bottom: 0;
				}
			}
		}

		.nav-footer-bottom-main {
			border-top: 3px solid $colour-primary-100;
			border-bottom: 3px solid $colour-primary-100;
		}

		.nav-footer-bottom-secondary {
			border-bottom: 3px solid $colour-primary-100;
		}

		.nav-footer-address {
			color: $core-neutral-900;
			padding: rem(24) 0 0;
			align-items: center;
			text-align: center;

			h6 {
				font-family: $font-header-medium;
				font-weight: 400;
				font-size: rem(20);
				line-height: 150%;
				letter-spacing: 0.5px;
				margin-bottom: rem(8);
			}

			p {
				font-weight: 400;
				font-size: rem(18);
				line-height: 150%;
				letter-spacing: 0.5px;
				margin-top: 0;
				flex-shrink: 0;
				margin-right: initial;
				margin-left: initial;
				max-width: initial;
			}
		}

		@include min(768px) {
			justify-content: space-between;
			flex-direction: row;
			align-items: flex-start;
			margin-top: rem(32);

			.nav-footer-bottom-main, .nav-footer-bottom-secondary {
				padding-top: 0;
				padding-bottom: 0;
				align-items: flex-start;

				a {
					padding: 0;
					margin-bottom: rem(16);
					border-top: none;
					font-weight: 500;
					font-size: rem(20);
					line-height: 150%;
					letter-spacing: 0.5px;

					&:hover {
						text-decoration: underline;
					}
				}
			}

			.nav-footer-bottom-main {
				border-top: none;
				border-bottom: none;
				margin-right: rem(16);
			}

			.nav-footer-bottom-secondary {
				border-bottom: none;
				margin-right: rem(16);
				margin-left: rem(16);
			}

			.nav-footer-address {
				padding: 0;
				margin-left: rem(16);
				text-align: left;

				h6 {
					font-weight: 500;
				}

				p {
					font-weight: 500;
					font-size: rem(20);
				}
			}
		}
	}

	.nav-footer-copyright {
		display: block;
		font-weight: 500;
		font-size: rem(20);
		line-height: 150%;
		letter-spacing: 0.5px;
		color: $core-neutral-900;
		margin-top: rem(24);
		margin-bottom: rem(58);
		margin-left: auto;
    	margin-right: auto;
		padding: 0 rem(29.5);

		@include min(768px) {
			margin-top: rem(32);
			margin-bottom: rem(60);
			margin-left: initial;
    		margin-right: initial;
			padding: 0;
		}
	}
}
/* Navigation */


/*
	======
	Search
	======
*/

.form-search {
	@include min(768px) {
		margin-left: auto;
		width: 33.3333%;
	}

	label {
		display: none;
	}

	[role=group] {
		display: table;
		display: flex;
	}

	.form-item,
	.form-buttons {
		display: table-cell;
		display: flex;
	}

	.form-item {
		flex-grow: 1;
		padding-right: 10px;
	}
}
/* Search */


/*
	========
	Carousel
	========
*/
.carousel {
	.carousel-item {
		height: 200px;

		@include min(768px) {
			height: 300px;
		}

		&.item-1 {
			background: #FCC;
		}
		&.item-2 {
			background: #CFC;
		}
		&.item-3 {
			background: #CCF;
		}
		&.item-4 {
			background: #FCF;
		}
	}

	.slick-next {
		right: 10px;
	}

	.slick-prev {
		left: 10px;
	}

	.wrap {
		height: 200px;

		@include min(768px) {
			height: 300px;
		}
	}

	.text {
		background: rgba(255,255,255,0.5);
		padding: 10px;
		width: 33.3333%;
	}
}
/* Carousel */


/*
	====
	Hero
	====
*/
.hero-banner {
	align-items: center;
	background-position: center center;
	background-size: cover;
	display: flex;
	max-height: 50vh;
	height: 500px;
	width: 100%;
}

.hero-text {
	background-color: transparentize($colour-highlight, 0.5);
	color: $colour-highlight-contr;
	max-width: 33.3333%;
	min-width: 250px;
	padding: rem($font-size-xl);
}
.hero-text_header {
	font-size: rem($font-size-xl);
	text-transform: uppercase;
}
/* Hero */


/*
	===========
	Breadcrumbs
	===========
*/
.page-breadcrumbs {
	position: relative;
	z-index: 50;

	a {
		background-color: transparent;
		color: inherit;
		display: inline-block;
		padding-left: 2px;
		padding-right: 2px;
		transition: background-color 0.3s;

		&:focus {
			background-color: rgba(0,0,0,0.25);
		}
	}
}
.breadcrumbs {
	@extend %list-reset;
	background-color: rgba(255, 255, 255, 0.7);
	font-size: rem(10);
	font-weight: 700;
	padding: 5px 8px;
	position: absolute;
	text-transform: uppercase;
	bottom: -96px;

	a {
		color: inherit;
		text-decoration: none;
	}

	li {
		color: $colour-alt;
		display: inline-block;

		&:after {
			content: '/';
		}

		&:last-child {
			color: $colour-base;

			&:after {
				content: '';
			}
		}
	}

	@include min(1024px) {
		bottom: initial;
	}
}
/* Breadcrumbs */


/*
	==========
	Home Boxes
	==========
*/
.home-boxes {
	@extend %clearfix;

	@include min(768px) {
		@include boxes(3);
	}

	.col {
		margin-bottom: 10px;
	}

	.inner {
		background: #EEF;
	}
}
/* Home Boxes */


/*
	=======
	Listing
	=======
*/
.post {
	@extend %clearfix;

	.image {
		@include min(768px) {
			float: left;
			max-width: 180px;
		}

		+ .text {
			@include min(768px) {
				margin-left: 200px;
			}
		}
	}
}
/* Listing */


/*
	===========
	Share Links
	===========
*/
.share-links {
	text-align: center;

	a {
		display: inline-block;
		overflow: hidden;
		position: relative;
		vertical-align: top;

		&:before {
			background-size: contain;
			content: '';
			display: inline-block;
			vertical-align: middle;
			width: 24px;
			height: 24px;
		}

		+ a {
			margin-left: 10px;
		}
	}

	.off-screen {
		position: absolute;
		left: -9999px;
	}

	.icon-pinterest {
		&:before {
			background-image: url(/site/images/vendor/Pinterest-badge-72px.png);
		}
	}
	.icon-facebook {
		&:before {
			background-image: url(/site/images/vendor/FB-f-Logo__blue_72.png);
		}
	}
	.icon-twitter {
		&:before {
			background-image: url(/site/images/vendor/twitter-64.png);
		}
	}
	.icon-googleplus {
		&:before {
			background-image: url(/site/images/vendor/gplus-64.png);
		}
	}
}
/* Share Links */


/*
	==============
	Content Blocks
	==============
*/
// Generic block styling
.content-block,
.content-layout {
	opacity: 1;
	transition: all 0.5s;

	+ .cb-rte {
		margin-top: rem(60);

		@include min(768px) {
			margin-top: rem(120);
		}
	}

	+ .cb-rte__highlight,
	+ .cb-rte__highlight-light,
	+ .cb-rte__dark {
		margin-top: 0;
	}

	+ .cb-iconitem {
		margin-top: 20px;
	}

	+ .content-block_collapse {
		margin-top: 0;
	}

	+ .cb-blog {
		margin-top: 0;
	}

	&.outofview {
		opacity: 0;
		transform: translateY(100px);
	}

	.button.comb-register {
		font-size: rem(24);
		background-color: $colour-smoking;
		border: none;

		&:before {
			background-color: $colour-smoking-dk;
		}
	}
}

.content-layout {
	+ .content-block {
		margin-top: rem(60);

		@include min(768px) {
			margin-top: rem(120);

		}
	}
}

.content-block__panel {
	background-color: $colour-highlight-lt;
	padding: 35px 25px;
}

.cb-rte {
	background-position: center center;
	background-size: cover;

	+ .content-block,
	+ .content-layout,
	+ .cb-rte {
		margin-top: rem(60);

		@include min(768px) {
			margin-top: rem(120);

		}
	}

	+ .cb-image {
		margin-top: rem(30);
	}

	.button {
		margin-top: 5px;

		@include min(768px) {
			margin-top: 0;
		}
	}

	ul {
		color: $colour-highlight;
		list-style: none;
		padding-left: 0;

		li {
			background-image: url(/site/images/icon/highlight/carousel-next.svg);
			background-position: 25px 5px;
			background-size: 5px 10px;
			padding-left: 40px;

			+ li {
				margin-top: 8px;
			}
		}
	}

	&.cb-rte__highlight,
	&.cb-rte__highlight-light,
	&.cb-rte__dark {
		padding-top: rem(60);
		padding-bottom: rem(60);

		@include min(768px) {
			padding-top: rem(120);
			padding-bottom: rem(120);
		}

		h2 {
			color: inherit;
		}
	}

	&.cb-rte__highlight,
	&.cb-rte__dark {
		color: #FFF;
	}

	&.cb-rte__highlight-light {
		background-color: $colour-highlight-lt;
	}

	&.cb-rte__highlight {
		background-color: $colour-highlight;
	}
	&.cb-rte__dark {
		background-color: $colour-dk;
	}


	+ .cb-rte__highlight,
	+ .cb-rte__highlight-light,
	+ .cb-rte__dark {
		margin-top: 0;
	}

	+ .cb-btn {
		@include min(768px) {
			margin-top: -100px;
		}
	}
}

.cb-btn {
	padding-bottom: rem(60);

	&.cb-btn.cb-rte__highlight-light {
		background-color: $colour-highlight-lt;
	}

	&.cb-btn.cb-rte__highlight {
		background-color: $colour-highlight;
	}
	&.cb-btn.cb-rte__dark {
		background-color: $colour-dk;
	}
}

// Signposts
.cb-signposts {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
}
.cb-signposts_block {
	align-items: flex-end;
	background-position: center center;
	background-size: cover;
	color: #FFF;
	display: flex;
	position: relative;

	flex-basis: 0;
	flex-grow: 1;
	max-width: 100%;
	min-width: 320px;
	min-height: 320px;

	@include min(768px) {
		flex-basis: 33.3333%;
		min-height: 410px;
	}

	h2 {
		color: inherit;
		font-size: rem(30);
		font-weight: 700;
		line-height: 1.3333;
	}

	p {
		font-size: rem(18);
		font-weight: 700;
		// opacity: 0;
		// position: absolute;
		// max-width: 100%;
		// max-width: calc(100% - 110px);
	}

	&:before,
	&:after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		transition: opacity 0.3s;
	}

	&:before {
		/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,1+50,1+100 */
		background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 50%, rgba(0,0,0,1) 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 50%,rgba(0,0,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 50%,rgba(0,0,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 ); /* IE6-9 */
		opacity: 0.5;
	}

	&:after {
		background-color: #671375;
		opacity: 0;
	}

	&:hover {

		&:before {
			opacity: 0;
		}

		&:after {
			opacity: 0.75;
		}

		p {
			max-width: 100%;
			opacity: 1;
			position: static;
			transition: opacity 0.3s;
		}

		.button {
			background-color: transparent;
		}
	}
}
.cb-signposts_block_inner {
	padding: 20px 20px 30px;
	position: relative;
	text-align: center;
	width: 100%;
	z-index: 20;

	@include min(768px) {
		padding: 55px 80px;
	}
}

// Testimonial
.cb-testimonial {
	blockquote {
		border-left: 4px solid $colour-highlight;
		margin: 0;
		padding: 10px 20px;
	}

	cite {
		display: block;
		margin-top: 1.4em;
	}
}
.cb-testimonial_right {
	text-align: right;

	blockquote {
		border-left: none;
		border-right: 4px solid $colour-highlight;
	}
}

// Map
.cb-map {
	@extend .iframe-embed;
	background-position: center center;
	background-size: cover;
	height: 500px;
    max-height: 50vh;
}

// Image
.cb-image {
	img {
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
}

.cb-nav {
	ul {
		// @extend %list-reset;
	}
}

// Activities Search
.cb-activities-search {
	background-color: $colour-highlight-lt;
	padding-top: rem(60);
	padding-bottom: rem(60);

	@include min(768px) {
		padding-top: rem(120);
		padding-bottom: rem(120);
	}

	form {
		font-size: rem(40);
		font-weight: 900;
		text-align: center;

		@include min(768px) {
			line-height: 1;
		}
	}

	input {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $colour-alt;
		color: $colour-alt;
		display: inline-block;
		font-size: rem(40);
		font-weight: 900;
		height: 41px;
		line-height: 1;
		padding: 0;
		width: 178px;
	}

	.niceselect-wrapper {
		background-color: transparent;
		border: none;
		border-bottom: 1px solid $colour-alt;
		color: $colour-alt;
		display: inline-block;
		line-height: 1;
		min-width: 200px;
		overflow: visible;
		padding: 0;

		&:after {
			background-image: url(/site/images/icon/alt/chevron-down.svg);
			background-size: 18px 11px;
			border: none;
			width: 18px;
			height: 11px;
		}
	}

	.niceselect-text {
		display: block;
		padding-right: 36px;
	}
}

.cb-panels {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	h2,
	h3 {
		color: inherit;
		font-size: 30px;
		font-weight: 700;
	}

	p {
		font-size: 18px;
		font-weight: 700;
	}

	.cb-panels_panel {
		color: #FFF;
		min-width: 250px;
		padding: 40px 40px;
		text-align: center;
		text-decoration: none;

		flex-basis: 100%;
		flex-grow: 0;
		max-width: 100%;
		box-shadow: $very-light-drop-shadow;
		margin-top: 0;

		&:hover {
			box-shadow: $light-drop-shadow;
		}

		@include min(768px) {
			flex-basis: 33.3333%;
		}

		&:nth-child(6n+1) {
			background-color: #671375;
		}
		&:nth-child(6n+2) {
			background-color: #26acb5;
		}
		&:nth-child(6n+3) {
			background-color: #adbf28;
		}
		&:nth-child(6n+4) {
			background-color: #e7b42f;
		}
		&:nth-child(6n+5) {
			background-color: #c5372e;
		}
		&:nth-child(6n+6) {
			background-color: #262626;
		}
    }

    &.cols-four {
		margin-top: rem(40) !important;
		margin-bottom: rem(40);
		margin-right: rem(16);
		margin-left: rem(16);
		opacity: 0;
		transform: translateY(200px);
		transition: all 1s;

		.docready & {
			opacity: 1;
			transform: translateY(0);
		}

		.h1 {
			font-family: $font-header-bold;
			font-style: normal;
			font-weight: 500;
			font-size: rem(30);
			line-height: 120%;
			text-align: center;
			letter-spacing: -0.25px;
			color: inherit;
			text-transform: lowercase;
			margin-bottom: rem(24);
			color: $core-neutral-900;
			width: 100%;

			&::first-letter {
				text-transform: capitalize;
			}

			@include min(540px) {
				font-size: rem(40);
			}
		}

		h2 {
			font-family: $font-header-medium;
			font-style: normal;
			font-weight: 500;
			font-size: rem(22);
			line-height: 120%;
			text-align: center;
			letter-spacing: 0.25px;
			color: inherit;
			text-transform: capitalize;
		}

		h2 + p {
			margin-top: rem(4);
		}

		p {
			font-family: 'TodaySB-Regular';
			font-style: normal;
			font-weight: 500;
			font-size: rem(20);
			line-height: 150%;
			text-align: center;
			letter-spacing: 0.3px;
		}

        .cb-panels_panel {
			display: flex;
			flex-direction: column;
			align-items: center;
			color: $core-neutral-900;
			background: $core-neutral-100;
			text-decoration: none;
			border-radius: rem(12);
			overflow: hidden;
			margin: rem(8);
			width: calc(50% - rem(16));
			min-width: initial;
			padding: 0;
			flex-basis: initial;
			flex-grow: initial;
			max-width: initial;
			border-bottom: 3px solid $colour-secondary-200;
			border-right: 3px solid $colour-secondary-200;
			border-left: 3px solid $colour-secondary-200;

			.cb-panels_panel-img {
				background-color: $colour-secondary-200;
				padding: rem(16) 0;
				width: 100%;
				display: flex;
				justify-content: center;

				img {
					height: rem(56);
					width: rem(56);

					@include min(768px) {
						height: rem(100);
						width: rem(100);
					}
				}
			}

			.cb-panels_panel-contents {
				padding: rem(16);
				display: flex;
				flex-direction: column;
    			justify-content: center;
				height: 100%;

				h2 {
					font-size: rem(22);
					line-height: 1.5;
					letter-spacing: rem(-0.25);
				}

				p {
					display: none;
				}
			}
        }

		@include min(420px) {
			.cb-panels_panel {
				.cb-panels_panel-contents {
					p {
						display: block;
						font-size: rem(16);
						line-height: 1.5;
						letter-spacing: rem(0.25);
					}
				}
			}
		}

		@include min(768px) {
			margin-top: rem(64) !important;
			margin-bottom: rem(64);
			margin-right: rem(8);
			margin-left: rem(8);

			h2 {
				font-size: rem(26);
			}

			.cb-panels_panel {
				margin: rem(16);
				width: calc(50% - rem(32));

				.cb-panels_panel-contents {
					h2 {
						font-size: rem(26);
						line-height: 120%;
						letter-spacing: rem(0.25);
					}

					p {
						font-size: rem(20);
						letter-spacing: rem(0.5);
					}
				}
			}
		}

		@include min(1200px) {
			margin-right: rem(64);
			margin-left: rem(64);

			.cb-panels_panel {
				width: calc(25% - rem(32));
			}
		}
    }

    &.cols-five {
        .cb-panels_panel {
            @include min(768px) {
                flex-basis: 20%;
            }
        }
    }

	&.cb-panels__forcecolumns {
		justify-content: center;

		.cb-panels_panel {
			flex-grow: 0;
			flex-basis: 100%;

			@include min(640px) {
				flex-basis: 50%;
			}

			@include min(960px) {
				flex-basis: 33.3333%;
			}
		}
	}
}

.cb-hero {
	z-index: 1;

	@include min(768px) {
		display: flex;
		flex-direction: column;
		justify-content: center;
		overflow: hidden;
		flex-direction: row-reverse;
		height: 478px;
	}

	h1,
	h2 {
		+ * {
			margin-top: rem(8);
		}
	}

	h1 {
		color: $core-neutral-900;
		font-size: rem(35);
		letter-spacing: -0.01em;
		line-height: 1;
		text-transform: lowercase;
		font-family: $font-header-bold;
		font-weight: 500;
		font-size: rem(38);
		line-height: 120%;
		letter-spacing: -0.25px;

		&::first-letter {
			text-transform: capitalize;
		}

		@include min(768px) {
			font-size: rem(45);
		}
	}

	h2 {
		color: inherit;
	}

	p {
		font-size: rem(20);
		line-height: 150%;
		letter-spacing: 0.5px;
		color: $core-neutral-900;
		display: flex;
		flex-direction: column;
		width: 100%;

		@include min(540px) {
			flex-direction: row;
		}

		@include min(768px) {
			flex-direction: column;
		}

		@include min(900px) {
			flex-direction: row;
		}

		+ * {
			margin-top: rem(24);
		}

		.button {
			justify-content: center;

			& + .button {
				margin-top: rem(16);
				margin-left: 0;

				@include min(540px) {
					margin-top: 0;
					margin-left: rem(16);
				}

				@include min(768px) {
					margin-top: rem(16);
					margin-left: 0;
				}

				@include min(900px) {
					margin-top: 0;
					margin-left: rem(16);
				}
			}
		}
	}

	.cb-hero-img {
		height: 30vh;
		flex-basis: 100%;
		max-width: 100%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;

		@include min(540px) {
			height: 50vh;
		}

		@include min(768px) {
			height: initial;
			max-width: 50%;
		}
	}

	.cb-hero_inner {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		max-width: 100%;
		background-color: $core-neutral-200;
		padding: rem(40) rem(24);

		img {
			margin-bottom: rem(16);
		}

		h1 {
			margin-top: 0;
		}

		p {
			.button {
				height: rem(56);
			}
		}

		@include min(540px) {
			p {
				.button {
					width: rem(184);
				}
			}
		}

		@include min(768px) {
			flex-basis: 100%;
			max-width: 50%;

			img {
				display: none;
			}

			p {
				.button {
					width: initial;
				}
			}
		}

		@include min(900px) {
			p {
				.button {
					width: rem(184);
				}
			}
		}

		@include min(1200px) {
			padding: rem(92) rem(80);
		}
	}

	.cb-hero_buttons {
		margin-top: 70px;
	}

	&.cb-hero__alt {
		&:before {
			background-position: -800px -1250px;

			@include min(1500px) {
				background-position: 0 -1250px;
			}
		}
	}
}

.cb-what-happen-this-month {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding-top: rem(40);
	padding-bottom: rem(48 - 16);
	background-color: $core-neutral-200;
	opacity: 0;
	transform: translateY(200px);
	transition: all 1s;

	.docready & {
		opacity: 1;
		transform: translateY(0);
	}

	.cb-what-happen-this-month-container {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		padding-right: rem(8);
		padding-left: rem(8);

		.h1 {
			font-family: $font-header-bold;
			font-size: rem(30);
			line-height: 120%;
			text-align: center;
			letter-spacing: -0.25px;
			color: $core-neutral-900;
			text-transform: lowercase;
			margin-bottom: rem(32 - 16);
			margin-right: rem(16);
			margin-left: rem(16);
			width: 100%;

			&::first-letter {
				text-transform: capitalize;
			}

			@include min(540px) {
				font-size: rem(40);
			}
		}

		.cb-what-happen-this-month_panel {
			display: inline-flex;
			flex-direction: column;
			background: $core-neutral-100;
			box-shadow: $very-light-drop-shadow;
			border-radius: rem(12);
			margin: rem(16);
			width: calc(100% - rem(32));
			overflow: hidden;
			text-decoration: none;

			&:hover {
				box-shadow: $light-drop-shadow;
			}

			.cb-what-happen-this-month_panel-img {
				background-position: center center;
				background-size: cover;
				min-height: rem(175);
			}

			.cb-what-happen-this-month_panel-contents {
				padding: rem(32);

				span {
					display: inline-block;
					font-weight: 500;
					font-size: rem(18);
					line-height: 100%;
					letter-spacing: 0.25px;
					color: $colour-primary-500;
					background-color: $colour-primary-100;
					border: 3px solid $colour-primary-500;
					border-radius: rem(44);
					padding: rem(7) rem(13) rem(4);
					text-transform: capitalize;
					margin-bottom: rem(16);
				}

				h2 {
					font-family: $font-header-medium;
					font-style: normal;
					font-weight: 500;
					font-size: rem(26);
					line-height: 120%;
					letter-spacing: -0.25px;
					color: $core-neutral-900;
					text-transform: capitalize;
				}

				p {
					font-weight: 500;
					font-size: rem(18);
					line-height: 150%;
					letter-spacing: 0.5px;
					color: $core-neutral-900;
					margin-top: 0;

					& + .button {
						margin-top: rem(16);
					}
				}

				.button {
					width: 100%;
					justify-content: center;
				}
			}

			&.featured {
				flex-direction: column;

				.cb-what-happen-this-month_panel-img {
					width: 100% !important;
				}

				.cb-what-happen-this-month_panel-contents {
					width: 100% !important;
				}
			}
		}
	}

	@include min(540px) {
		.cb-what-happen-this-month-container {
			.cb-what-happen-this-month_panel {
				.cb-what-happen-this-month_panel-contents {
					.button {
						width: initial;
					}
				}
			}
		}
	}

	@include min(768px) {
		padding-top: rem(72);
		padding-bottom: rem(80 - 16);

		.cb-what-happen-this-month-container {
			.cb-what-happen-this-month_panel {
				width: calc(50% - rem(32));

				&.featured {
					flex-direction: row !important;
					width: calc(100% - rem(32)) !important;
					margin-right: rem(16);
					margin-left: rem(16);

					.cb-what-happen-this-month_panel-img {
						width: 50% !important;
					}

					.cb-what-happen-this-month_panel-contents {
						width: 50% !important;
					}
				}
			}
		}
	}

	@include min(1200px) {
		.cb-what-happen-this-month-container {
			padding-right: rem(64);
			padding-left: rem(64);

			h1 {
				margin-right: rem(16);
				margin-left: rem(16);
			}
		}
	}

	&.cols-three {
		.cb-what-happen-this-month-container {
			.cb-what-happen-this-month_panel {
				margin: rem(16);
				width: calc(100% - rem(32));

				@include min(1200px) {
					margin: rem(16);
					width: calc(33.33% - rem(32));
				}
			}
		}
	}
}

.cb-banner {
	align-items: center;
	background-position: center center;
	background-size: cover;
	color: #FFF;
	display: flex;
	justify-content: center;
	min-height: 260px;
	overflow: hidden;
	padding-top: 10px;
	padding-bottom: 10px;
	position: relative;
	text-align: center;

	@include min(1024px) {
		height: 260px;
	}

	.wrap {
		margin-left: 0;
		margin-right: 0;
	}

	+ .content-layout,
	+ .cb-form {
		margin-top: rem(60);

		@include min(768px) {
			margin-top: rem(120);
		}
	}

	+ .cb-rte__highlight,
	+ .cb-rte__highlight-light,
	+ .cb-rte__dark {
		margin-top: 0;
	}

	&:before {
		background-image: url(/site/images/flower.svg);
		background-position: -1000px -1150px;
		background-size: 3000px auto;
		content: '';
		opacity: 0.75;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 10;
	}

	h1 {
		font-size: rem(35);
		line-height: 1;

		+ * {
			margin-top: 10px;
		}

		@include min(768px) {
			font-size: rem(70);
		}
	}

	p {
		font-size: rem(18);
		line-height: 1.4;

		@include min(768px) {
			font-size: rem(26);
		}
	}

	.wrap {
		// position: relative;
		z-index: 20;
	}

	.cb-banner_button {
		z-index: 20;

		@include min(768px) {
			margin-top: 0;
			position: absolute;
			top: 12px;
			right: 12px;
		}
	}
}

.cb-story {
	align-items: stretch;
	background-color: $colour-highlight-lt;
	border-bottom: 1px solid $colour-highlight-lt;
	border-top: 1px solid $colour-highlight-lt;
	display: flex;
	flex-wrap: wrap;

	@include min(768px) {
		flex-wrap: nowrap;
	}

	h2,
	h3 {
		text-transform: uppercase;

		+ * {
			margin-top: 0;
		}
	}

	.cb-story_image {
		background-color: #FFF;
		background-image: url(/site/images/placeholder/512x512.jpg);
		background-position: center center;
		background-size: contain;
		display: none;
		min-height: 150px;
		max-width: 100%;

		@include min(768px) {
			display: block;
			flex: 0 0 240px;
			min-height: 325px;
		}

		@include min(1024px) {
			flex: 0 0 480px;
		}
	}

	.cb-story_content {
		flex-grow: 1;
		flex-basis: auto;
		max-width: 100%;
		padding: 50px;
	}

	.button {
		display: block;
		text-align: center;
		width: 100%;

		+ .button {
			margin-top: 20px;
		}

		@include min(450px) {
			display: inline-block;
			width: auto;

			+ .button {
				margin-left: 20px;
				margin-top: 0;
			}
		}
	}

	&.cb-story__reverse {
		background-color: #FFF;

		.cb-story_image {
			order: 2;
		}
		.cb-story_content {
			order: 1;
		}
	}

	+ .cb-story {
		margin-top: -1px;
	}
}
.cb-stories {
	.cb-story {
		&:nth-child(2n) {
			background-color: #FFF;

			.cb-story_image {
				order: 2;
			}
			.cb-story_content {
				order: 1;
			}
		}
	}
}

.cb-threesteps {
	background-color: $colour-highlight-lt;
	color: $colour-highlight;
	counter-reset: steps;
	padding-bottom: 100px;

	h3 {
		text-transform: uppercase;
	}

	.cb-threesteps_intro {
		align-items: center;
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		justify-content: center;
		padding-top: 75px;
		padding-bottom: 75px;

		@include min(768px) {
			flex-direction: row;
			justify-content: space-between;
		}

		h2 {
			+ * {
				@include min(768px) {
					margin-top: 0;
				}
			}
		}

		h2,
		.link {
			flex-grow: 1;
			flex-basis: 0;
			max-width: 100%;
		}

		.link__refresh {
			@include max(767px) {
				padding-right: 0;
			}
		}
	}
	.cb-threesteps_steps {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
	.cb-threesteps_step {
		counter-increment: steps;
		flex-grow: 1;
		flex-basis: 100%;
		max-width: 640px;

		@include min(768px) {
			flex-basis: 33.3333%
		}
	}
	.cb-threesteps_step_image {
		padding-bottom: 50%;
	}
	.cb-threesteps_step_text {
		padding: 70px 35px;
		position: relative;
		text-align: center;

		&:before {
			background-color: #FFF;
			border-radius: 50%;
			color: $colour-highlight;
			content: counter(steps);
			font-size: rem(50);
			font-weight: 900;
			line-height: 1.5em;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			width: 1.5em;
			top: -0.75em;
		}
	}
}

.cb-quote {
	overflow: hidden;
	padding-top: 85px;
	position: relative;
	text-align: center;

	&:before {
		background-image: url(/site/images/flower.svg);
		background-size: 100% auto;
		content: '';
		opacity: 0.6;
		position: absolute;
		left: 0;
		top: 0;
		height: 1920px;
		width: 1920px;
		transform: rotateZ(-45deg) translateX(65%) translateY(0%);
		background-position: center;
	}

	p {
		font-size: rem(18);
		font-weight: 700;

		@include min(768px) {
			font-size: rem(30);
		}
	}
	cite {
		color: $colour-highlight;
		display: block;
		font-size: rem(20);
		font-style: normal;
		font-weight: 700;
		text-align: center;
		text-transform: uppercase;

		+ * {
			margin-top: 0.666em;
		}
	}
	blockquote {
		margin: 0 0 60px;
		padding-left: 10px;
		padding-right: 10px;
		position: relative;

		padding: 60px 10px;

		@include min(768px) {
			padding: 120px 0;
		}

		.cb-quote_quote_mark-left,
		.cb-quote_quote_mark-right {
			// display: none;
			left: 50%;
			transform: translateX(-50%);
			width: 60px;

			@include min(768px) {
				display: block;
				width: 120px;
			}
		}

		.cb-quote_quote_mark-left {
			top: 0;
		}
		.cb-quote_quote_mark-right {
			bottom: 0;
		}
	}
	.cb-quote_slider {
		.slick-prev,
		.slick-next {
			height: auto;
			width: auto;
			margin-top: 0;
			transform: translateY(-50%);

			&:before {
				content: none;
			}

			svg {
				width: 20px;

				@include min(768px) {
					width: 51px;
				}
			}
		}

		.slick-prev {
			left: 5px;

			@include min(768px) {
				left: 80px;
			}
		}
		.slick-next {
			right: 5px;

			@include min(768px) {
				right: 80px;
			}
		}
	}
	.cb-quote_quote {}
	.cb-quote_quote_image {
		display: inline-block;
		max-width: 500px;
		padding-left: 40px;
		padding-right: 40px;
		position: relative;

		@include min(768px) {
			padding-left: 140px;
			padding-right: 140px;
		}

		img {
			border-radius: 50%;
			display: block;
		}

		.cb-quote_quote_mark-left,
		.cb-quote_quote_mark-right {
			display: none;
			top: 0;

			@include min(768px) {
				display: block;
			}
		}

		.cb-quote_quote_mark-left {
			left: 0;
		}
		.cb-quote_quote_mark-right {
			right: 0;
		}

		+ blockquote {
			padding-top: 30px;
			padding-bottom: 0;
			.cb-quote_quote_mark-left,
			.cb-quote_quote_mark-right {
				display: none;
			}
		}
	}

	.cb-quote_quote_mark-left,
	.cb-quote_quote_mark-right {
		opacity: 0.3;
		position: absolute;
	}

	.cb-quote_quote_mark-left {}
	.cb-quote_quote_mark-right {}

	&.cb-quote__slim {
		padding-top: 0;

		&:before {
			display: none;
		}

		blockquote {
			margin-bottom: 0;
		}
	}
}

.cb-info {
	color: #FFF;
	display: flex;
	flex-wrap: wrap;
	text-align: center;
	width: 100%;

	h2 {
		color: #FFF;
		font-size: rem(30);
		font-weight: 700;
	}
	p {
		font-size: rem(18);
		font-weight: 700;
	}
}
.cb-info_block {
	background-color: #666;
	display: flex;
	flex-direction: column;
	// flex: 1 0 auto;
	flex-basis: 0;
	flex-grow: 1;
	max-width: 100%;

	&:nth-child(1) {
		.cb-info_block_image {
			background-image: url(/site/images/content/info-1.jpg);
		}
	}
	&:nth-child(2) {
		.cb-info_block_image {
			background-image: url(/site/images/content/info-2.jpg);
		}
	}
}
.cb-info_block_image {
	align-items: center;
	background-position: center center;
	background-size: cover;
	display: flex;
	height: 412px;
	position: relative;

	@include min(768px) {
		align-items: flex-end;
	}

	&:after {
		background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 ); /* IE6-9 */
		content: '';
		opacity: 0.8;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 1;
	}
}
.cb-info_block_image_inner {
	padding: 45px;
	position: relative;
	width: 100%;
	z-index: 10;
}
.cb-info_block_text {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	justify-content: space-between;
	padding: 30px;

	@include min(768px) {
		padding: 60px;
	}
}
.cb-info_block_links {
	+ p {
		margin-top: 1.4em;
	}
}

.cb-big-video {
	background-image: url(/site/images/flower.svg);
	background-position: center center;
	background-size: cover;
	position: relative;

	+ .cb-rte__highlight,
	+ .cb-rte__highlight-light,
	+ .cb-rte__dark {
		margin-top: 0;
	}

	.cb-big-video_embed {
		left: -9999px;
		opacity: 0;
		overflow: hidden;
		padding-bottom: 75%;
		position: relative;
		transition: opacity 0.3s;
		width: 0;
		z-index: 10;

		@include min(768px) {
			padding-bottom: 45%;
		}


		iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}

	.cb-big-video_over {
		color: #FFF;
		font-size: rem(40);
		font-weight: 700;
		opacity: 1;
		position: absolute;
		text-align: center;
		top: 50%;
		left: 0;
		text-transform: uppercase;
		width: 100%;
		transform: translateY(-50%);
		transition: opacity 0.3s;

		small {
			display: block;
			font-size: rem(20);
		}

		&:before {
			background-color: $colour-alt;
			background-image: url(/site/images/icon/white/carousel-next.svg);
			background-position: center center;
			background-size: auto 10vw;
			border-radius: 50%;
			content: '';
			cursor: pointer;
			display: block;
			margin: 0 auto 10px;
			max-width: 146px;
			max-height: 146px;
			width: 15vw;
			height: 15vw;

			@include min(768px) {
				// background-position: 58px center;
				background-size: 37px 70px;
				margin-bottom: 50px;
			}

			@include min(1024px) {
				background-position: 58px center;
			}
		}
	}

	&.cb-big-video__novid {
		.cb-big-video_over {
			&:before {
				visibility: hidden;
			}
		}
	}

	&.cb-big-video__play {
		.cb-big-video_embed {
			left: 0;
			opacity: 1;
			width: 100%;

		}
		.cb-big-video_over {
			opacity: 9;
		}
	}
}

.cb-blog {
	.content-layout_wrap {
		padding-top: 64px;
		padding-bottom: 64px;
	}
	.content-layout_column {
		position: relative;
	}
}
.cb-blog_options {
	display: flex;
	flex-wrap: wrap;
	margin-left: -10px;
	margin-right: -10px;
	padding-bottom: 10px;

	.cb-blog_types,
	.cb-blog_views {
		flex-basis: 100%;
		flex-grow: 0;
		padding: 10px;

		@include min(768px) {
			flex-basis: 50%;
		}
	}

	.niceselect-wrapper {
		max-width: 333px;
	}
}
.cb-blog_listing {
	@extend %list-reset;
	display: flex;
	flex-wrap: wrap;
	margin: -15px;

	li {
		display: flex;
		flex-direction: column;
		flex: 0 0 100%;
		justify-content: space-between;
		padding: 25px 15px;

		@include min(768px) {
			flex-basis: 50%;
		}
	}
	.cb-blog_listing_item_wrap {
		background-color: $colour-alt;
		position: absolute;
		top: 25px;
		left: 15px;
		width: 50px;
		height: 50px;
		z-index: 20;
	}
	.cb-blog_listing_button {
		margin-top: 16px;
	}


	.cb-blog_listing_item_fav {
		background-color: white;
		mask: url(/site/images/icon/white/star.svg) no-repeat center center;
		mask-size: 31px 31px;
		cursor: pointer;
		width: 50px;
		height: 50px;

		&.cb-blog_listing_item_fav_on {
			background-color: white;
			mask: url(/site/images/icon/white/star-filled.svg) no-repeat center center;
			mask-size: 31px 31px;
			cursor: pointer;
			width: 50px;
			height: 50px;
		}
	}
}
.cb-blog_listing.faq {
	li {
		@include min(768px) {
			flex-basis: 33.3333%;
		}
	}
}
.cb-blog_listing__tools {
	li {
		flex-basis: 100%;
		flex-grow: 0;

		@include min(540px) {
			flex-basis: 50%;
		}

		@include min(768px) {
			flex-basis: 33.3333%;
		}
	}
}
.cb-blog_listing__activity {
	li {
		flex-basis: 100%;
		flex-grow: 0;
		max-width: 100%;
		position: relative;

		@include min(540px) {
			flex-basis: 50%;
			max-width: 50%;
		}

		@include min(768px) {
			flex-basis: 33.3333%;
			max-width: 33.3333%;
		}
	}

	h2 {
		line-height: 1;
	}

	.cb-blog_listing_item_image {
		overflow: hidden;
		position: relative;
		z-index: 10;
	}

	.cb-blog_listing_item_image__placeholder {
		background-color: $colour-highlight;
		background-image: url(/site/images/flower-outline.svg);
		background-position: center center;
		background-size: 75% auto;
		padding-bottom: 65%;

		&:before {
			content: '';
			background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 25%, rgba(0,0,0,0.5) 75%, rgba(0,0,0,0.5) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 25%,rgba(0,0,0,0.5) 75%,rgba(0,0,0,0.5) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 25%,rgba(0,0,0,0.5) 75%,rgba(0,0,0,0.5) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#80000000',GradientType=0 ); /* IE6-9 */
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
	}

	.cb-blog_listing_item_text_inner {
		display: none;
		margin-top: 0;

		a {
			text-decoration: none;
		}
	}

	.cb-blog_listing_item_text_desc {
		height: auto;
		max-height: 4.5em;
		overflow: hidden;
	}

	.cb-blog_listing_item_toggle {
		background-color: $colour-alt;
		background-image: url(/site/images/icon/white/phone.svg);
		background-position: center center;
		background-size: 31px 31px;
		border: none;
		border-radius: 0;
		cursor: pointer;
		position: absolute;
		top: 25px;
		right: 15px;
		width: 50px;
		height: 50px;
		z-index: 20;
	}

	.cb-blog_listing_item_badge {
		background-color: $colour-highlight;
		color: #FFF;
		font-size: rem(18);
		font-weight: 700;
		bottom: 0;
		left: 0;
		padding: 12px 20px;
		position: absolute;
		text-transform: uppercase;
	}

	.cb-blog_listing__toggle {
		.cb-blog_listing_item_image {
			display: none;
		}
		.cb-blog_listing_item_text {
			padding-top: 50px;
		}
		.cb-blog_listing_item_text_inner {
			display: block;
		}
		.cb-blog_listing_item_toggle {
			background-image: url(/site/images/icon/white/close.svg);
			background-size: 29px 29px;
		}

		.cb-blog_listing_item_text_desc {
			max-height: none;
		}
		.cb-blog_listing_item_text_link {
			display: none;
		}
	}
}
.cb-blog_listing_item {
	h2,
	p {
		margin-top: 8px;
	}

	h2 {
		line-height: 1;
	}

	p {
		line-height: 1.5;
		word-break: break-word;

        &.h4 {
            font-size: rem(14);
        }
	}

	a {
		text-decoration: none;
	}
}
.cb-blog_listing_item_date {
	font-size: rem(18);
}
.cb-blog_bar {
	background-color: $colour-alt;
	padding: 10px 0;
}
.cb-blog_filters {
	color: #FFF;
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	justify-content: space-between;

	@include min(768px) {
		flex-direction: row;
	}

	> div {
		flex-basis: auto;
		flex-grow: 1;
	}

	> .cb-blog_sortby {
		flex-basis: 100%;

		@include min(980px) {
			flex-basis: auto;
		}
	}
}
.cb-blog_views {
	padding-bottom: 30px;
	text-align: right;

	button {
		background-color: transparent;
		border: none;
		color: $colour-alt;
		cursor: pointer;
		font-size: rem(16);
		padding: 0;
		transition: color 0.3s;

		&:hover {
			color: darken($colour-alt, 10%);

			path {
				fill: darken($colour-alt, 10%);
			}
		}

		+ button {
			margin-left: 1em;
		}
	}

	svg {
		display: inline-block;
		overflow: visible;
		vertical-align: middle;
	}

	path {
		fill: $colour-alt;
		transition: fill 0.3s;
	}

	+ * {
		margin-top: 0;
	}
}
.cb-blog_pathways {
	display: flex;
	flex-wrap: wrap;
	margin-left: -10px;
	margin-right: -10px;

	.input-replacement {
		color: #FFF;
		display: block;
		flex-basis: 100%;
		margin: 0;
		padding-left: 10px;
		padding-right: 10px;
		padding-top: 4px;
		vertical-align: top;

		@include min(768px) {
			flex-basis: auto;
		}
	}
}
.cb-blog_sortby {
	flex-basis: 100%;
	margin-top: 10px;
	text-align: left;

	@include min(768px) {
		margin-top: 0;
		text-align: right;
	}

	label {
		font-size: rem(14);
		font-weight: 700;
	}

	.niceselect-wrapper {
		display: inline-block;
		min-width: 204px;
		vertical-align: middle;
	}
}
.cb-blog_pagination {
	color: #FFF;
	font-size: rem(18);
	font-weight: 700;
	text-align: center;
	text-transform: uppercase;

	ul {
		@extend %list-reset;
	}

	li {
		display: inline-block;

		+ li {
			padding-left: 8px;
		}
	}

	a {
		color: inherit;
		display: block;
		line-height: 30px;
		text-decoration: none;
		min-width: 30px;
	}

	.active {
		color: $colour-alt;

		a {
			background-color: #FFF;
			border-radius: 50%;
		}
	}

	.pagination_prev,
	.pagination_next {
		a {
			background-color: transparent;
			background-size: 12px 18px;
			padding: 0;
			width: auto;
		}
	}

	.pagination_prev {
		a {
			background-image: url(/site/images/icon/white/chevron-left.svg);
			background-position: 0 center;
			padding-left: 24px;
		}
	}
	.pagination_next {
		a {
			background-image: url(/site/images/icon/white/chevron-right.svg);
			background-position: right center;
			padding-right: 24px;
		}
	}
}
.cb-blog_tags {
	padding-top: 10px;
	text-align: center;

	h3 {
		font-size: rem(18);
		text-transform: uppercase;

		+ ul {
			margin-top: 5px;
		}
	}

	ul {
		@extend %list-reset;
		font-size: rem(18);
		margin-left: auto;
		margin-right: auto;
		width: 80%;
	}

	li {
		+ li {
			border-top: 1px solid $colour-alt;
		}
	}

	a {
		display: block;
		padding: 9px 0 5px;
		text-decoration: none;
		transition: color 0.3s, background-color 0.3s;

		&:hover {
			background-color: $colour-alt;
			color: #FFF;
		}
	}
	.active {
		a {
			background-color: $colour-alt;
			color: #FFF;
		}
	}

	+ .cb-blog_tags {
		margin-top: 15px;
	}
}
.cb-blog_map {
	height: 500px;
	margin-top: 20px;
	position: relative;

	h2 {
		text-transform: none;
		font-size: rem(20);
	}

	p {
		margin: 0;
	}
}
.cb-blog_hidden {
	position: absolute;
	left: -300%;
	// visibility: hidden;
	width: 100%;
}

.cb-contact {
	margin-top: rem(60);

	@include min(768px) {
		margin-top: rem(120);
	}

	h3 {
		font-size: rem(26);
		letter-spacing: -0.05em;
		text-transform: uppercase;
	}

	.cb-contact_number {
		display: block;
		line-height: 17px;
	}

	.content-layout_column {
		align-items: stretch;
		display: flex;
	}
	.cb-rte {
		width: 100%;
	}
}

.cb-iconitem {
	align-items: center;
	color: $colour-highlight;
	display: flex;
	font-size: rem(20);
	font-weight: 700;

	img {

	}

	.cb-iconitem_img {
		margin-right: 20px;
		flex-basis: 48px;
		text-align: center;
	}
	.cb-iconitem_txt {}
}

.cb-table {
	table {
		width: 100%;
	}
	th {
		background-color: $colour-highlight;
		color: #FFF;
		font-weight: 700;
		padding: 5px;
		text-transform: uppercase;
	}

	td {
		background-color: #e8dcea;
		color: $colour-highlight;
		padding: 5px;
	}

	tr {
		&:nth-child(2n) {
			td {
				background-color: #d1b8d5;
			}
		}
	}
}

.cb-discounts {
	background-color: $colour-dk;
	color: #FFF;
	display: flex;
	justify-content: center;
	padding: 70px 0;

	h2 {
		color: inherit;
		font-size: rem(30);
		font-weight: 700;
	}

	.wrap {
		min-height: 106px;

		@include min(768px) {
			background-image: url(/site/images/icon/white/discounts.svg);
			padding-left: 140px;
			width: auto;
		}
	}

	.cb-discounts_phone {
		background-image: url(/site/images/icon/white/phone.svg);
		background-position: left center;
		background-size: 31px 31px;
		font-size: rem(30);
		font-weight: 700;
		padding-left: 45px;
	}

	.cb-discounts_phone_times {
		font-size: rem(18);
		font-weight: 500;
	}
}

.cb-team {
	color: #FFF;

	h3,
	p {
		font-weight: 700;
		margin: 0;
		position: relative;
		z-index: 1;
	}

	h3 {
		color: inherit;
		font-size: rem(20);
		text-transform: uppercase;
	}

	a {
		color: inherit;
		text-decoration: none;
	}

	.team {
		@extend %list-reset;
		display: flex;
		flex-wrap: wrap;
		margin-left: -1px;
	}
	.team_member {
		background-color: #999;
		background-image: url(/site/images/flower-outline.svg);
		background-position: center center;
		background-size: cover;
		border-bottom: 1px solid #FFF;
		border-left: 1px solid #FFF;
		display: flex;
		flex-basis: 100%;
		flex-direction: column;
		flex-grow: 0;
		justify-content: flex-end;
		max-width: 100%;
		min-height: 195px;
		padding: 18px;
		position: relative;

		@include min(500px) {
			flex-basis: 50%;
		}

		@include min(768px) {
			flex-basis: 33.3333%;
		}

		@include min(1024px) {
			flex-basis: 25%;
		}

		@include min(1200px) {
			flex-basis: 20%;
		}

		&:nth-child(7n+1) {
			background-color: $colour-highlight; // Purple
		}
		&:nth-child(7n+2) {
			background-color: $colour-alt; // Teal
		}
		&:nth-child(7n+3) {
			background-color: #333; // Charcoal
		}
		&:nth-child(7n+4) {
			background-color: $colour-smoking; // Red
		}
		&:nth-child(7n+5) {
			background-color: $colour-drink; // Yellow
		}
		&:nth-child(7n+6) {
			background-color: #a6b637; // Green
		}
		&:nth-child(7n+7) {
			background-color: $colour-smoking-dk; // Dark Red
		}

		&:before {
			content: '';
			background: -moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 25%, rgba(0,0,0,0.5) 75%, rgba(0,0,0,0.5) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 25%,rgba(0,0,0,0.5) 75%,rgba(0,0,0,0.5) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 25%,rgba(0,0,0,0.5) 75%,rgba(0,0,0,0.5) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#80000000',GradientType=0 ); /* IE6-9 */
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 0;
		}
	}

	.team_member__noimage {
		background-position: 30px 15px;
		background-position: right -30px bottom -15px;
		background-size: 265px auto;
	}
}
/* Content Blocks */


/*
	=====
	Forms
	=====
*/
.form-activities-search {
	.form-activities-search_button {
		background-color: transparent;
		border: none;
		color: $colour-alt;
		cursor: pointer;
		display: block;
		font-size: rem(30);
		font-weight: 700;
		margin: 10px auto 0;
		padding: 0;
		text-transform: uppercase;
		vertical-align: middle;

		svg {
			display: inline-block;
			fill: $colour-alt;
			vertical-align: middle;
			margin-left: 0.1em;
		}

		@include min(768px) {
			display: inline-block;
			margin: 0;

			span {
				display: none;
			}

			svg {
				margin-left: 0;
			}
		}
	}
}

.form-register {
	fieldset {
		display: none;
		position: relative;
	}

	.form-register__active {
		display: block;
	}

	.form-register_row {
		display: flex;
		flex-wrap: wrap;
		margin-left: -15px;
		margin-right: -15px;

		+ .form-register_row {
			margin-top: 30px;
		}
	}

	.form-register_col {
		flex-basis: 100%;
		padding-left: 15px;
		padding-right: 15px;

		@include min(768px) {
			max-width: 50%;
		}
	}

	.form-register_field {
		align-items: flex-start;
		display: flex;

		label {
			display: block;
			flex-basis: 40%;
			flex-grow: 0;
			padding-right: 10px;
			padding-top: 5px;
			text-align: right;

			&.error {
				// color: #F00;
				padding-top: 0;
				text-align: left;
				color: red;
			}
		}

		.form-register_input {
			flex-basis: 60%;
		}

		+ .form-register_field {
			margin-top: 10px;
		}
	}

	.form-register_bmi {
		align-items: flex-start;
		display: flex;
		width: 100%;
		justify-content: center;
		text-align: left;

		+ * {
			margin-top: 1em;
		}

		label {
			&.error {
				padding-left: 20px;
			}
		}

		.form-register_bmi_label {
			flex-basis: 200px;
			padding-top: 4px;
			text-align: right;
		}

		.form-register_bmi_fields {
			flex-basis: 400px;
			flex-grow: 0;
		}

		.form-register_bmi_group {
			align-items: center;
			display: flex;
			padding-left: 10px;
			padding-right: 10px;

			label {
				align-items: center;
				display: flex;
				flex-basis: 200px;
				flex-grow: 0;
				padding-left: 10px;
				padding-right: 10px;
			}

			input {
				width: 100px;
				flex-basis: 100px;
				flex-grow: 1;
			}
		}
		.form-register_bmi_group_unit {
			padding-left: 5px;
		}

		.form-register_bmi_switch {
			align-items: stretch;
			border-radius: 4px;
			display: flex;
			overflow: hidden;
			position: relative;

			input {
				position: absolute;
				left: -999px;

				&:checked {
					+ span {
						background-color: $colour-highlight;
						color: #FFF;
					}
				}
			}

			label {
				flex-basis: 50%;
				flex-grow: 0;

				+ label {
					// border-left: 1px solid $colour-input-border;
				}
			}

			span {
				background-color: #CCC;
				cursor: pointer;
				display: block;
				padding: 5px 10px;
			}
		}
	}

	.form-register_smokingstop,
	.form-register_smokingfollowup {
		margin-top: 1em;
	}

	.form-register_alcohol {
		max-width: 512px;
		margin-left: auto;
		margin-right: auto;

		+ * {
			margin-top: 1.4em;
		}
	}

	.form-register_alcohol_row {
		align-items: center;
		display: flex;
		margin-left: -10px;
		margin-right: -10px;
		position: relative;

		label {
			text-align: right;
		}

		label,
		.form-register_alcohol_field {
			flex-basis: 50%;
			padding-left: 10px;
			padding-right: 10px;
		}
	}

	.form-register_question {
		max-width: 300px;
		margin-left: auto;
		margin-right: auto;

		+ * {
			margin-top: 1.4em;
		}

		&.justifycentre {
			max-width: 90%;

			label {
				display: block;
				margin-bottom: 0.5em;
			}
			input, .niceselect-wrapper {
				max-width: 300px;
				margin: auto;
			}
		}

		.error {
			color: red;
		}
	}
}

.form-activityfinder {
    & > .wrap {
        max-width: rem(720);
    }

    h2 {
        text-transform: capitalize;
        letter-spacing: -0.03em;

        & + p {
            font-size: rem(16);
            line-height: 1.3;
            margin-top: 0;

            & + .form_item {
                margin-top: rem(20);
            }

            @include min(768px) {
                font-size: rem(18);
            }
        }
    }

    .form {
        label {
            color: $colour-black;
            font-weight: 500;
            letter-spacing: -0.02em;
            text-transform: capitalize;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            &.error {
                color: #F00;
            }
        }

        input[type=text],
        input[type=password],
        input[type=datetime],
        input[type="datetime-local"],
        input[type=date],
        input[type=month],
        input[type=time],
        input[type=week],
        input[type=number],
        input[type=email],
        input[type=url],
        // input[type=search],
        input[type=tel],
        input[type=color],
        textarea,
        .niceselect-wrapper {
            appearance: none;
            border: 1px solid #D0D0CE;
            line-height: 1.5;
            font-weight: 400;
            width: 100%;
            height: rem(54);
            border-radius: 2px;
            color: $colour-black;
            background: $colour-base-contr;
            padding: rem(15);
            outline: none;

            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                line-height: 1;
            }
        }

        select::-ms-expand {
            display: none;
        }

        textarea {
            resize: none;
            height: auto;
        }

        input[type=file] {
            border: none;
            width: 100%;

            &::-webkit-file-upload-button {
                color: white;
				background-color: $colour-primary-500;
				border: 3px solid $colour-primary-500;
				border-radius: 0.75rem;
				display: inline-flex;
				align-items: center;
				font-family: $font-header-bold;
				font-size: 20px;
				letter-spacing: 0.5px;
				line-height: 1.2;
				transition: all 0.3s linear;
				text-decoration: none;
				text-transform: capitalize;
				padding: 9px 18px 5px;
				margin: 0;
				cursor: pointer;
				margin-right: rem(8);
            }

			&:hover,
			&:focus {
				&::-webkit-file-upload-button {
					background-color: $colour-primary-700;
					border-color: $colour-primary-700;
					color: white;
				}
			}
        }

        .niceselect-wrapper {
            &:after {
                background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNiA2TDExIDEiIHN0cm9rZT0iIzQzNDM0MyIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPg==');
                background-repeat: no-repeat;
                background-size: 12px 8px;
                background-position: center center;
            }

            .niceselect-text {
                color: $colour-base;
            }
        }

        .required label::after {
            content: 'required';
            color: rgba(95, 36, 120, 0.5);
            font-size: rem(16);
            letter-spacing: -0.02em;
        }

        .select2-container {
            .select2-selection--multiple {
                border: 1px solid #D0D0CE;
                min-height: rem(54);
                border-radius: 2px;
                color: $colour-black;
                background: $colour-base-contr;
                padding: rem(8) rem(15);
            }

            &::after {
                content: '';
                display: block;
                position: absolute;
                top: 50%;
                right: 10px;
                width: 18px;
                height: 11px;
                background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNiA2TDExIDEiIHN0cm9rZT0iIzQzNDM0MyIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPg==');
                background-repeat: no-repeat;
                background-size: 12px 8px;
                background-position: center center;
                transform: translateY(-50%);
                z-index: 5;
            }
        }
    }

    .input-checkbox {
        input[type=checkbox] {
            display: block;
            width: 0;
            height: 0;
            opacity: 0;
            margin: 0;
            padding: 0;

            & + label {
                position: relative;
                padding-top: 2px;
                padding-left: 30px;
                font-size: rem(16);
                line-height: 1.25;
                font-weight: 400;
                color: $colour-base;
                padding-bottom: 0;
                text-transform: none;

                &::before {
                    content: '';
                    display: block;
                    width: 20px;
                    height: 20px;
                    border: 1px solid $colour-black;
                    border-radius: 2px;
                    background: $colour-background;
                    position: absolute;
                    top: 0;
                    left: 0;
                }

                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDQuMzc1TDMuNDgyNzYgN0w5IDEiIHN0cm9rZT0iIzI2QUNCNSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 10px 9px;
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    transition: opacity 0.2s linear;
                }
            }

            &:checked + label {
                &::after {
                    opacity: 1;
                }
            }
        }

        &.with-icon {
            display: flex;
            flex-direction: row;
            align-items: center;

            & > img {
                width: rem(30);
                height: rem(30);
                margin-right: 10px;
            }
        }
    }

    .form_item {
        &.small-gap + .small-gap {
            margin-top: rem(10);
        }

        & + h2 {
            margin-top: rem(30);
        }

        & + .form_item {
            margin-top: rem(20);
        }
    }

    .form-footer {
        padding: rem(30);
        margin-top: rem(35);
		margin-right: rem(-30);
		margin-left: rem(-30);
		background: rgba(95, 36, 120, 0.1);

        .input-checkbox input[type=checkbox] + label {
            font-size: rem(16);

            @include min(768px) {
                font-size: rem(18);
            }
        }

        .button {
			margin-top: 1.25rem;
		}
    }

    .cb-banner + & {
        margin-top: rem(40);
    }
}

.form-request-resources {
	.form-item-nhs-health-check-flyer label {
		margin-bottom: 2.03125rem;
	}

	@media (max-width: 822px) {
		.form-item-nhs-health-check-flyer label {
			margin-bottom: 0;
		}
	}
}
/* Forms */


/*
	=====
	Com-B
	=====
*/
.comb {
	h2 {
		text-align: center;

		+ * {
			margin-top: 60px;
		}
	}

	.cb-panels {
		margin-top: 60px;
		+ * {
			margin-top: 60px;
		}
	}

	.comb_section {
		display: none;
		padding: 50px 0;
		padding: 60px 0;
		position: relative;

		@include min(768px) {
			padding: 120px 0;
		}
	}
	.comb_section__show {
		display: block;
	}

	.comb_pathway {
		padding-bottom: 70px;

		@include min(768px) {
			padding-bottom: 140px;
		}
	}
	.comb_pathway_select {
		color: $colour-highlight;
		display: block;
		font-size: rem(40);
		text-align: center;
		text-transform: uppercase;

		+ * {
			margin-top: 1em;
		}

		.niceselect-wrapper {
			background-color: transparent;
			border: none;
			border-bottom: 1px solid $colour-alt;
			display: inline-block;
			font-weight: 700;
			line-height: inherit;
			vertical-align: middle;

		}
	}
	.comb_pathway_next {
		background-color: $colour-highlight;
		border: none;
		border-radius: 50%;
		width: 80px;
		height: 80px;
		left: 50%;
		margin-left: -40px;
		padding: 0;
		position: absolute;
		bottom: 0;
		margin-bottom: -40px;

		svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateY(-50%) translateX(-50%);
		}
	}

	.comb_section_scale {
		padding-top: 140px;

		h2 {
			+ * {
				margin-top: 10px;
			}
		}
	}
	.comb_scale {
		@extend %list-reset;
		background-position: center top;
		display: flex;
		flex-wrap: wrap;
		margin: 40px auto 0;
		max-width: 1370px;
		text-align: center;

		@include min(1320px) {
			background-image: url(/site/images/bg/comb_scale.png);
			padding-top: 100px;
		}

		+ * {
			margin-top: 1em;
		}

		li {
			flex: 0 0 100%;
			overflow: hidden;
			position: relative;

			@include min(768px) {
				flex-basis: 25%;
			}

			+ li {
				margin-top: 4em;

				@include min(768px) {
					margin-top: 0;
				}
			}

			&:first-child {
				.comb_scale_item_inner {
					&:before {
						left: 50%;
						width: 50%;
					}
				}
			}
			&:last-child {
				.comb_scale_item_inner {
					&:before {
						right: 50%;
						width: 50%;
					}
				}
			}
		}

		label {
			&:hover {
				.comb_scale_item_inner {
					h3 {
						color: $colour-alt;
					}

					&:after {
						background-image: url(/site/images/icon/alt/check.svg);
						border-color: $colour-alt;
					}
				}
			}
		}

		h3 {
			text-transform: uppercase;
			transition: color 0.3s;

			+ * {
				margin-top: 0;
			}
		}

		input {
			left: -999px;
			position: absolute;

			&:checked {
				+ .comb_scale_item_inner {
					h3 {
						color: $colour-alt;
					}

					&:after {
						background-image: url(/site/images/icon/alt/check.svg);
						border-color: $colour-alt;
					}
				}
			}
		}

		.comb_scale_item_inner {
			padding: 85px 20px 0;
			position: relative;

			&:before {
				background-color: $colour-highlight;
				position: absolute;
				height: 10px;
				width: 100%;
				left: 0;
				top: 23px;

				@include min(768px) {
					content: '';
				}
			}

			&:after {
				background-color: #FFF;
				background-image: url(/site/images/icon/grey/check.svg);
				background-position: center center;
				background-size: 31px 24px;
				border: 2px solid $colour-highlight;
				border-radius: 50%;
				content: '';
				cursor: pointer;
				height: 56px;
				width: 56px;
				position: absolute;
				top: 0;
				left: 50%;
				margin-left: -28px;
				transition: border-color 0.3s;
			}
		}
	}

	.comb_challenges {
		@extend %list-reset;
		display: flex;
		flex-wrap: wrap;
		margin-top: 60px;

		@include min(768px) {
			margin-top: 120px;
		}

		li {
			background-color: #CCC;
			display: flex;
			flex: 0 0 50%;
			overflow: hidden;
			position: relative;

			@include min(768px) {
				flex-basis: 25%;
				min-height: 282px;
			}

			&:nth-child(8n+2),
			&:nth-child(8n+4),
			&:nth-child(8n+5),
			&:nth-child(8n+7) {
				@include min(768px) {
					background-color: #AAA;
				}
			}
		}

		label {
			color: #FFF;
			display: flex;
			padding: 32px 5px;
			padding: 32px;
			width: 100%;

			&:hover {
				// background-color: #FFF;
				// color: $colour-alt;
			}
		}

		input {
			position: absolute;
			left: -999px;

			&:checked {
				+ .comb_challenges_item_inner {
					&:after {
						background-image: url(/site/images/icon/alt/check.svg);
					}
				}
			}
		}

		h3 {
			color: inherit;
			margin-top: 0;
			text-align: center;

			+ * {
				margin-top: 1em;
			}
		}

		p {
			color: inherit;
			font-weight: 700;
			text-align: center;
		}

		.comb_challenges_item_inner {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 100%;

			&:after {
				background-color: #FFF;
				background-image: url(/site/images/icon/grey/check.svg);
				background-position: center center;
				background-size: 31px 24px;
				border-radius: 50%;
				content: '';
				cursor: pointer;
				display: block;
				margin: 30px auto 0;
				width: 56px;
				height: 56px;
			}

			img {
				height: 101px;
			}
		}

		&.comb_challenges__hacks {
			li {
				background-color: #CCC;
				flex-basis: 100%;

				@include min(768px) {
					flex-basis: 33.3333%;
				}

				&:nth-child(2n+1) {
					background-color: #AAA;
				}
			}

			label {
				padding: 32px;
			}
		}
	}

	&[data-pathway="activity"] {
		.comb_challenges {
			li {
				background-color: $colour-active;

				&:nth-child(4n+2),
				&:nth-child(4n+3) {
					background-color: $colour-active-dk;

					@include min(768px) {
						background-color: $colour-active;
					}
				}

				&:nth-child(8n+2),
				&:nth-child(8n+4),
				&:nth-child(8n+5),
				&:nth-child(8n+7) {
					@include min(768px) {
						background-color: $colour-active-dk;
					}
				}
			}

			&.comb_challenges__hacks {
				li {
					background-color: $colour-active;

					&:nth-child(2n+1) {
						background-color: $colour-active-dk;
					}
				}
			}
		}
	}
	&[data-pathway="weight"] {
		.comb_challenges {
			li {
				background-color: $colour-weight;

				&:nth-child(4n+2),
				&:nth-child(4n+3) {
					background-color: $colour-weight-dk;

					@include min(768px) {
						background-color: $colour-weight;
					}
				}

				&:nth-child(8n+2),
				&:nth-child(8n+4),
				&:nth-child(8n+5),
				&:nth-child(8n+7) {
					@include min(768px) {
						background-color: $colour-weight-dk;
					}
				}
			}

			&.comb_challenges__hacks {
				li {
					background-color: $colour-weight;

					&:nth-child(2n+1) {
						background-color: $colour-weight-dk;
					}
				}
			}
		}
	}
	&[data-pathway="smoking"] {
		.comb_challenges {
			li {
				background-color: $colour-smoking;

				&:nth-child(4n+2),
				&:nth-child(4n+3) {
					background-color: $colour-smoking-dk;

					@include min(768px) {
						background-color: $colour-smoking;
					}
				}

				&:nth-child(8n+2),
				&:nth-child(8n+4),
				&:nth-child(8n+5),
				&:nth-child(8n+7) {
					@include min(768px) {
						background-color: $colour-smoking-dk;
					}
				}
			}

			&.comb_challenges__hacks {
				li {
					background-color: $colour-smoking;

					&:nth-child(2n+1) {
						background-color: $colour-smoking-dk;
					}
				}
			}
		}
	}
	&[data-pathway="alcohol"] {
		.comb_challenges {
			li {
				background-color: $colour-drink;

				&:nth-child(4n+2),
				&:nth-child(4n+3) {
					background-color: $colour-drink-dk;

					@include min(768px) {
						background-color: $colour-drink;
					}
				}

				&:nth-child(8n+2),
				&:nth-child(8n+4),
				&:nth-child(8n+5),
				&:nth-child(8n+7) {
					@include min(768px) {
						background-color: $colour-drink-dk;
					}
				}
			}

			&.comb_challenges__hacks {
				li {
					background-color: $colour-drink;

					&:nth-child(2n+1) {
						background-color: $colour-drink-dk;
					}
				}
			}
		}
	}

	#comb-step-3,
	#comb-step-4 {
		padding-top: 0;
	}
}
/* Com-B */


.svg-defs {
	display: none;
}
.svg-next,
.svg-prev {
	fill: $colour-alt;
}
.svg-slick {}

/*
	========================
	Events / Organisation
	========================
*/
.text-thumbnail {
    @extend .aspect-ratio-image;

    @include min(768px) {
        & + .inner {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
}

.cb-image-side-hero {
    display: flex;
    flex-direction: column;

    .image-container {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: stretch;

        .image-item {
            position: relative;
            width: calc(100% + 60px);
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            max-height: calc((100% - (100% - 1200px)) * 0.5);
        }

        .text-thumbnail {
            z-index: 1;
            margin-left: -30px;
            margin-right: -30px;
            width: auto;

            &::before {
                padding-bottom: 70%;
            }

            &::after {
                background: linear-gradient(52.91deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0) 100%);
            }

            & + .inner {
                padding: 30px 0 0 0;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                z-index: 1;

                h1 {
                    font-size: rem(28);
                    color: $colour-black;
                    line-height: 1;
                }

                p {
                    font-size: rem(10);
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.1em;
                    color: $secondary-orange;
                    line-height: 1.5;
                }
            }
        }
    }

    .image-container .image-item.logo-only {
        margin-left: 0;
        width: 100%;

        .text-thumbnail {
            border-bottom: 2px solid #D0D0CE;
            // background-size: auto auto;

            &::after {
                content: none;
            }
        }
    }

    .hero-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 20px 0 0;

        h2 {
            font-size: rem(20);
            font-weight: 600;
            line-height: 1.5;
            letter-spacing: -0.03em;
            color: $colour-black;
            margin-bottom: 20px;
            width: 100%;
        }

        ul {
            @extend %list-reset;
            max-width: 100%;

            li {
                display: flex;
                flex-direction: row;
                align-items: flex-start;

                .icon {
                    margin-right: 7px;
                    width: 12px;
                    flex-shrink: 0;
                }

                p, a {
                    font-size: rem(16);
                    line-height: 1.3;
                    color: $colour-black;
                    width: 100%;

                    br {
                        display: none;
                    }
                }

                & + li {
                    margin-top: 16px;
                }
            }

            & + .button {
                margin-top: 16px;
            }
        }
    }

    @include min(768px) {
        flex-direction: row;
        align-items: stretch;

        .image-container {
            flex-basis: 58.33%;
            max-width: 58.33%;

            .image-item {
                margin-left: -30px;
            }

            .text-thumbnail {
                margin-left: 0;
                margin-right: 0;
                width: 100%;
                height: 100%;

                & + .inner {
                    padding: 0 30px 30px 30px;

                    h1 {
                        font-size: rem(50);
                        color: $colour-base-contr;
                    }

                    p {
                        font-size: rem(14);
                        color: $colour-base-contr;
                    }
                }
            }
        }

        .image-container .image-item.logo-only {
            .text-thumbnail {
                border: 2px solid #D0D0CE;

                &::before {
                    padding-bottom: 0;
                }

                & + .inner {
                    display: none;
                }
            }
        }

        .hero-content {
            justify-content: flex-end;
            flex-basis: 41.67%;
            max-width: 41.67%;
            background: rgba($secondary-green, 0.1);
            padding: 30px;

            h2 {
                font-size: rem(34);
                line-height: 1.1;
            }

            ul {
                li {
                    .icon {
                        margin-right: 15px;
                        width: 22px;
                    }

                    p, a {
                        font-size: rem(18);

                        br {
                            display: inline;
                        }
                    }

                    & + li {
                        margin-top: 20px;
                    }
                }

                & + .button {
                    margin-top: 30px;
                }
            }
        }
    }

    @include min(1260px) {
        .image-container {
            .image-item {
                margin-left: -60px;
            }

            .text-thumbnail + .inner {
                padding: 0 60px 60px 60px;
            }
        }

        .hero-content {
            padding: 60px;

            h2 {
                line-height: 1.5;
            }
        }
    }
}

.cb-features {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 5px;
    margin-top: 30px;
    margin-bottom: 30px;

    .feature-item {
        flex-basis: 100%;
        max-width: 100%;
        padding-bottom: 20px;

        p {
            font-size: rem(18);
            line-height: 1.3;
            color: $colour-black;

            &.bolder {
                font-weight: 700;
            }

            & + p {
                margin-top: 0;
            }
        }
    }

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #D0D0CE;
    }

    @include min(640px) {
        .feature-item {
            flex-basis: 50%;
            max-width: 50%;
        }

        &::after {
            width: 80px;
            height: 5px;
            background-color: $secondary-green;
        }
    }
}

.cb-report {
    margin-top: 20px;

    .report-text {
        font-size: rem(16);
        font-weight: 600;
        line-height: 1.2;
        letter-spacing: -0.02em;
    }

    .link__green {
        font-size: rem(16);
    }

    & + * {
        margin-top: 1.4em;
    }

    @include min(768px) {
        text-align: right;
    }
}

.content-layout_5-7, .organisation-main {
    .cb-map {
        height: 300px;
    }

    @include min(768px) {
        .cb-map {
            height: 500px;
        }
    }
}

.content-layout_column.content-layout_5-7-main {
    padding-top: 0;

    h2 {
        font-size: rem(20);
        letter-spacing: -0.03em;
        line-height: 1.1;
        font-weight: 600;
        text-transform: none;
        color: $colour-black;
    }

    @include min(768px) {
        padding-right: 30px;

        h1, .h1 {
            margin-top: 30px;
            font-size: rem(50);
        }

        h2 {
            font-size: rem(34);
        }
    }

    @include min(1260px) {
        padding-right: 60px;

        h1, .h1 {
            margin-top: 40px;
        }
    }
}

.organisation-main {
	display: flex;
	flex-direction: column;
	padding-top: 30px;

	h1, .h1 {
		font-size: rem(28);
		line-height: 1.1;
		color: $colour-black;
	}

	.cate-label {
		font-size: rem(14);
		font-weight: 700;
		letter-spacing: 0.1em;
		line-height: 1.5;
		text-transform: uppercase;
		margin-top: 0;
	}

	.cb-features {
		order: 1;
	}

	.cb-report {
		order: 2;
		margin-top: 0;
	}

	.link__green {
		order: 3;
	}

	@include min(640px) {
		padding-top: 0;

		.cb-features {
			order: 0;
		}

		.cb-report {
			margin-top: 30px;
		}
	}

	@include min(768px) {
		flex-direction: row;
		flex-wrap: wrap;

		& > *:not(.cb-features):not(.cb-report) {
			flex-basis: 100%;
			max-width: 100%;
		}

		h1, .h1 {
			margin-top: 30px;
			font-size: rem(50);
		}

		.cb-features {
			flex-basis: 58.33%;
			max-width: 58.33%;
		}

		.cb-report {
			order: 0;
			display: flex;
			flex-direction: row;
			align-items: flex-end;
			justify-content: flex-end;
			padding-bottom: 24px;
			flex-basis: 41.67%;
			max-width: 41.67%;
		}

		.cb-map {
			order: 1;
		}
	}

	@include min(1260px) {
		h1, .h1 {
			margin-top: 40px;
		}
	}
}
.form-search {
    margin: auto;
}

.search-results {
    .extract {
        margin-top: 0;
    }
}

#habit-hacker-cta .habit-hacker .site-style-button {
    display: flex;
    margin-left: auto;
    margin-right: auto;
}

.page-breadcrumbs + .content-area > #habit-hacker-full .habit-hacker {
    margin-top: rem(24);
}

.content-area {
	margin-top: 72px;
	background-color: $core-neutral-100;

	@include min(1024px) {
		margin-top: 0;
	}
}